
import * as C from './styles.js';
import { Link, useNavigate } from 'react-router-dom';

export default function Account({user, account, profile, setCopied }) {
    
    const navigate = useNavigate();

    const profileCreated = (e)=> {
        var dateMembro = new Date(Number(e));
        var dataMembroDesde = String(dateMembro.getDate()).padStart(2, '0') + '/' + String(dateMembro.getMonth()+1).padStart(2, '0') + "/" + dateMembro.getFullYear();
        
        return dataMembroDesde
    };

    const copyToClipboard = (text, type) => {
        navigator.clipboard.writeText(text)
          .then(() => {
            setCopied(type);
            setTimeout(() => {
                setCopied(false); 
            }, 5000);
          })
          .catch((error) => {
            console.error('Erro ao copiar texto para a área de transferência:', error);
          });
    };

    return (
        <C.Container>

            <C.Header>
                <button onClick={()=>navigate('/configuracoes/principal/')}><i className='fas fa-chevron-left'></i></button>
                <h3>Conta</h3>
            </C.Header>

            <C.Main>

                <C.Section>
                    <h2>{account?.account_name}</h2>
                    <p>{account?.account_email}</p>
                    <p className='email'>id: {user?.uid} <button className='show-string' onClick={()=>copyToClipboard(account?.account_uid, 'ID Conta')}><i class="fa-regular fa-copy"></i></button></p>
                    {user?.uid &&
                        <p className='account-created'>Conta criada em {profileCreated(user?.metadata.createdAt)}</p>
                    }
                </C.Section>

                <C.Section>
                    <C.Profiles className='profiles-actual'>
                        <h4>Seção atual</h4>
                        <C.ContentProfileActual>
                            <C.Profile className='profile-actual' isDisabled={true}>
                                <section>
                                    <div>
                                        <img loading='lazy' src={profile?.profile_photo_url} alt='profile'/>
                                    </div>
                                    <div>
                                        {(profile && profile?.profile_primary) &&
                                            <span className='span-main-account'>Perfil Principal</span>
                                        }
                                        <p className='name'>{profile?.profile_name}</p>
                                        <p className='profile-created'>Criado em {profileCreated(profile?.profile_created?.seconds * 1000)}</p>
                                        <p className='profile-created'>ID: {profile?.profile_uid} <button className='show-string' onClick={()=>copyToClipboard(profile?.profile_uid, 'ID Perfil')}><i class="fa-regular fa-copy"></i></button></p>
                                    </div>
                                </section>
                            </C.Profile>
                            {/*
                            <footer>
                                <Link to='/settings/edit-profile'><i className='fa-solid fa-edit'></i> Editar Perfil</Link>
                            </footer>
                             */}
                        </C.ContentProfileActual>
                    </C.Profiles>
                </C.Section>
                <C.Profiles>
                    <footer>
                        <Link to='/profiles/'><i className='fa-solid fa-repeat'></i> Gerenciar Perfis</Link>
                    </footer>
                </C.Profiles>
            </C.Main>
        </C.Container>
    )
}